import React from 'react'
import request from 'superagent';
import {getColorStyle, timeoutRedirect} from './Util';
import * as Categories from '../constants/Categories'
import {URL_CONSTITUTION} from "../constants/Url";
import {Link} from "react-router-dom";
// import TagManager from 'react-gtm-module';
// import {getTagManagerArgs} from './Util';

export default class Constitution extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      category_id: 15,
      category_name: '志向性/行動',
      results: {},
      toggleRisklevel: null
    }
  }

  handleToggleRisklevel(){
    if(this.state.toggleRisklevel){
      this.setState({toggleRisklevel: !this.state.toggleRisklevel})
    }else{
      this.setState({toggleRisklevel: true})
    }
  }

  handleClickOpen(unit_id) {
    const {handleModalOpen} = this.props;
    handleModalOpen(unit_id)
  }

  handleClickClose() {
    const {handleModalClose} = this.props;
    handleModalClose()
  }

  selectCategory(category) {
    let _results = this.state.results
    if(!_results[category.name] || 0 === _results[category.name].length) {
      request
        .get(URL_CONSTITUTION(this.props.access_token, this.props.gender, this.props.kit, category.categories))
        .set('Content-Type', 'application/json')
        .end((err, res) => {
          if (err) {
            console.log('error')
          }

          if (!res || !res.body.result) {
            timeoutRedirect()
          }

          _results[category.name] = res.body.result
          this.setState({
            toggleRisklevel: null,
            results: _results,
            category: category.categories,
            category_id: category.id,
            category_name: category.name
          })
        })
    } else {
      this.setState({
        toggleRisklevel: null,
        results: this.state.results,
        category: category.categories,
        category_id: category.id,
        category_name: category.name
      })
    }
  }

  componentWillMount() {
    this.selectCategory({id: 15, name: '志向性/行動', categories: Categories.ConstitutionIntentionalityBehavior});
  }

  componentDidMount() {
  }

  render() {
    // TagManager.initialize(getTagManagerArgs('/constitution/' + this.state.category_id));

    if(this.state.toggleRisklevel === true){
      this.state.results.sort(function(a,b){
        if(a.level_type<b.level_type) return 1;
        if(a.level_type > b.level_type) return -1;
        return 0;
      });
    }else if(this.state.toggleRisklevel === false){
      this.state.results.sort(function(a,b){
        if(a.level_type<b.level_type) return -1;
        if(a.level_type > b.level_type) return 0;
        return 0;
      });
    }

    const categories = [
      {id: 15, icon: 'image/icon/15.png', name: '志向性/行動', categories: Categories.ConstitutionIntentionalityBehavior},
      {id: 16, icon: 'image/icon/16.png', name: '能力', categories: Categories.ConstitutionAbility},
      {id: 17, icon: 'image/icon/17.png', name: '性別', categories: Categories.ConstitutionGender},
      {id: 18, icon: 'image/icon/18.png', name: '体型・体格', categories: Categories.ConstitutionBodyStructure},
      {id: 10, icon: 'image/icon/10.png', name: '骨・関節・皮膚', categories: Categories.ConstitutionOsteoSkin},
      {id: 12, icon: 'image/icon/12.png', name: '目・耳・鼻・口', categories: Categories.ConstitutionEyeEarNoseOral},
      {id: 11, icon: 'image/icon/11.png', name: '血液・免疫', categories: Categories.ConstitutionBloodImmunity},
      {id: 14, icon: 'image/icon/14.png', name: '栄養素', categories: Categories.ConstitutionNutrients},
      {id: 13, icon: 'image/icon/13.png', name: 'その他', categories: Categories.ConstitutionOthers},
      {id: 1, icon: 'image/icon/1.png', name: '全て', categories: Categories.ConstitutionAll},
    ];

    return (

      <div className="wrap">
        <div className="titlearea">
          <h2>体質カテゴリ一覧</h2>
          {/*<p className="printbtn">印刷する</p>*/}
        </div>

        <div className="category_icon">
          <ul>
            {categories.map(c =>
              (
                <li key={Math.random()} className={this.state.category_id === c.id ? "active" : ""}>
                  <p className="icon" onClick={this.selectCategory.bind(this, c)}><img src={c.icon} alt={c.name}/><span>{c.name}</span></p>
                </li>
              )
            )}
          </ul>
        </div>

        <div className="summary_table">
          <div className="inddata">
            <table>
              <thead>
              <tr>
                <th scope="col">検査項目</th>
                <th scope="col" className="updown">結果</th>
                <th scope="col">&nbsp;</th>
              </tr>
              </thead>
              <tbody>
              {(this.state.results[this.state.category_name] || []).map(data =>
                <tr key={Math.random()}>
                  <td className="name">{data.unit.name}</td>
                  <td className={`riskrevel ${getColorStyle(data.level_type, data.unit.id)}`}>{data.markup_level_name}</td>
                  <td className="detail">
                    <Link to={{
                      pathname: "/detail",
                      state: { referer: "/constitution" }
                    }} ><div className="show_detail" onClick={this.handleClickOpen.bind(this, data.unit.id)}>詳細を見る</div></Link>
                  </td>
                </tr>
              )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Constitution.js